export function parseRemoteConfigValue(value, valueType) {
    const trimmed = value.trim();
    switch (valueType) {
        case 'bool': {
            const lower = trimmed.toLowerCase();
            if (lower === 'true')
                return true;
            if (lower === 'false')
                return false;
            return undefined;
        }
        case 'int': {
            const parsed = parseInt(trimmed, 10);
            if (Number.isNaN(parsed))
                return undefined;
            if (String(parsed) !== trimmed)
                return undefined;
            return parsed;
        }
        case 'float': {
            const parsed = parseFloat(trimmed);
            if (Number.isNaN(parsed))
                return undefined;
            return parsed;
        }
        case 'string':
            return value;
        case 'json': {
            try {
                return JSON.parse(value);
            }
            catch {
                return undefined;
            }
        }
        default:
            return undefined;
    }
}
export function parseRemoteConfigs(rows, log) {
    const values = {};
    for (const row of rows) {
        const parsed = parseRemoteConfigValue(row.value, row.value_type);
        if (parsed === undefined) {
            const msg = `remote-config: failed to parse key="${row.key}" type="${row.value_type}" value="${row.value}"`;
            if (log)
                log(msg);
            continue;
        }
        values[row.key] = parsed;
    }
    return values;
}
//# sourceMappingURL=remote-config.js.map